import { Box } from "@mui/material";
import { useMemo } from "react";
import { Bar, BarChart, CartesianGrid, Cell, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Props } from "recharts/types/component/DefaultLegendContent";
import { monthsAbbreviated } from "src/constants";

interface PropostasTempoGraficoItemProps {
  "Data": string;
  "Propostas": number;
}

interface PropostasTempoGraficoProps {
  data: PropostasTempoGraficoItemProps[]
  isLoading: boolean
}

function CustomTick({ x, y, payload }: any){
  const tick = useMemo(()=>{
    const splitted = payload.value.split('/')
    if (splitted.length === 3) return {
      dia: splitted[0],
      mes: splitted[1],
      ano: splitted[2]
    }


    if (splitted.length === 2) return {
      mes: splitted[0],
      ano: splitted[1]
    }

    return { dia: '', mes: '', ano: '' }
  },[payload])

  if (tick.dia) {
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={-30}
          y={12}
          dy={0}
          dx={0}
          textAnchor="middle"
          fill="#000"
          style={{ fontSize: 12 }}
        >
          {`${tick.dia}/${tick.mes}/${tick.ano}`}
        </text>
      </g>
    )
  }

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={-10}
        y={12}
        dy={0}
        dx={0}
        textAnchor="middle"
        fill="#000"
        style={{ fontSize: 12 }}
      >
        {monthsAbbreviated[Number(tick.mes) - 1]}
      </text>
      <text
        x={-8}
        y={10}
        dy={16}
        dx={0}
        textAnchor="middle"
        fill="#000"
        style={{ fontSize: 12 }}
      >
        {tick.ano.substring(2,4)}
      </text>
    </g>
  )
}

function CustomLegend(props: Props){
  const payloads = props.payload || []
  return (
      <Box display="flex" alignItems={"center"} justifyContent={"center"} marginTop={"15px"}>
        {payloads.map(payload => (
            <Box marginRight={3} display={"flex"} alignItems={"center"} justifyContent={"center"}>
              <Box width={"20px"} height={"10px"} marginRight={"5px"} bgcolor={payload.color} />
              <span style={{ color: "#000" }}>{payload.value}</span>
            </Box>
          )
        )}
      </Box>
  )
}

export function PropostasTempoGrafico({ data, isLoading }: PropostasTempoGraficoProps){
  if (isLoading) {
    return (
      <Box display="flex" alignItems={"center"} justifyContent={"center"} height={"150px"}>
        <span>Buscando...</span>
      </Box>
    )
  }

  if (!data.length) {
    return <h2>Não há dados</h2>
  }

  return (
    <ResponsiveContainer>
      <BarChart data={data}>
      <XAxis dataKey="Data" tick={<CustomTick />} />
      <YAxis width={80} interval="preserveEnd" />
      <Tooltip itemStyle={{ color: '#2fac2d' }} formatter={value => {
          return `${Number(value)}`
        }} />
      <Legend content={<CustomLegend />} />
      <CartesianGrid opacity={"0.5"} />
      <Bar
        isAnimationActive={false}
        dataKey={'Propostas'}
        fill="rgba(139, 230, 138, 0.5)"
        stroke="rgba(139, 230, 138, 1)"
        >
        {data &&
          data.map((entry) => {
            return (
              <Cell key={`cell-${entry.Data}`} />
              );
            })}
      </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}